import { render, staticRenderFns } from "./ScrollBrowserBlock.vue?vue&type=template&id=3ba94e0b&"
import script from "./ScrollBrowserBlock.vue?vue&type=script&lang=js&"
export * from "./ScrollBrowserBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports